<template>
  <AppHeaderDropdown right no-caret class="nav-border">
    <template slot="header">
      <img
        class="img-avatar img-avatar-tamanho"
        :src="usuarioLogado.image ? usuarioLogado.image : 'https://www.pena.com.br/wp-content/uploads/2017/05/user-icon.jpg'"
        :alt="usuarioLogado.email"
      />
    </template>
    <template slot="dropdown">
      <b-dropdown-item to="/chatConfiguracoes">
        <i class="fa fa-shield" /> Settings
      </b-dropdown-item>
      <b-dropdown-item @click="sair">
        <i class="fa fa-lock" /> Logout
      </b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown,
  },
  data: () => ({ itemsCount: 42 }),
  computed: mapGetters(['usuarioLogado']),
  methods: {
    ...mapActions(['logout']),
    sair() {
      this.logout();
      this.$router.push({
        name: 'login',
      });
    },
  },
};
</script>
<style scoped>
.img-avatar-tamanho {
  height: 50px;
  width: 50px;
}
.nav-border  {
    margin-right: 32%
  }
</style>
